import { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.scss';
import clsx from 'clsx';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Button variant
   * - 'primary': Green solid button
   * - 'gradient': Turquoise gradient button
   * - 'outlined': White button with green border
   */
  variant?: 'primary' | 'gradient' | 'outlined';

  /**
   * Button size
   */
  size?: 'small' | 'medium' | 'large';

  /**
   * Full width button
   */
  fullWidth?: boolean;

  /**
   * Loading state
   */
  loading?: boolean;

  /**
   * Icon to display (Material Icons name)
   */
  icon?: string;

  /**
   * Button content
   */
  children: ReactNode;
}

export const Button = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = true,
  loading = false,
  icon,
  children,
  className,
  disabled,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={clsx(
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        loading && styles.loading,
        className,
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className={styles.spinner}></span>
      ) : (
        <>
          {icon && <span className="material-icons">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
};
